export default "__VITE_ASSET__7x1gIblQLfzctElDF6jsiw__"